<template>
    <v-img :src="backgroundUrl" class="mnt_image fill-height">
    <div id="signin_wrapper">
        <v-snackbar
            :timeout="actionDuration"
            v-model="actionDialog"
            centered
            top
            elevation="20"
            :color="actionColor"
            class="pa-6 pt-0"
            style="margin-top: 9%"
        >
            <div 
                class="text-center headline font-weight-medium"
                :class="actionColor == 'success' ? 'primary--text text--darken-2' : 'white--text'"
                v-html="actionMessage">
            </div>
        </v-snackbar>

        <v-container fluid>
            <v-row>
                <v-col cols="12" class="ma-3">
                    <div class="pl-6">
                        <v-icon color="white darken-2" class="mr-3 mt-n1">mdi-ray-end-arrow</v-icon> 
                        <a class="return_link sansation white--text text--darken-2" href="https://www.successionresource.com" target="_blank" >Return to SRG Home Page</a>
                    </div>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <div id="login" class="elevation-24">
                        <v-img :src="logo_img" width="225" class="d-block" style="margin: 0 auto" atl="Succession Resource Group"></v-img>
                        <div class="sansation grey--text text--darken-3 mt-3 mb-12 signin_title" v-text="'Create New Password'"></div>
                        <form @submit.prevent="logIn">
                            <div class="d-block sansation text-left">Password</div>
                            <div class="d-block">
                                <v-text-field 
                                    :append-icon="show_eye1 ? 'mdi-eye' : 'mdi-eye-off'"
                                    v-model="input.password"
                                    :type="show_eye1 ? 'text' : 'password'"  
                                    background-color="grey lighten-4"
                                    solo
                                    @click:append="show_eye1 = !show_eye1"
                                    :rules="passRules"
                                    required
                                ></v-text-field>
                            </div>
                            
                            <div class="d-block sansation text-left">Confirm Password</div>
                            <div class="d-block">
                                <v-text-field 
                                    :append-icon="show_eye2 ? 'mdi-eye' : 'mdi-eye-off'"
                                    v-model="input.confirm_password" 
                                    :type="show_eye2 ? 'text' : 'password'" 
                                    background-color="grey lighten-4"
                                    solo
                                    @click:append="show_eye2 = !show_eye2"
                                    :rules="cpassRules"
                                    required
                                ></v-text-field>
                            </div>

                            <v-btn color="primary" dark class="subtitle mt-3" type="submit">{{ submit_text }}</v-btn>
                        </form>
                    </div>
                </v-col>
            </v-row>
        </v-container>
    </div>
    </v-img>
</template>

<script>
    import axios from "axios";
    import Cookie from "js-cookie";
    import appUrls from '../helpers/environment';

    import logo_img from '../assets/SRGLogo_full_color_2022.svg';
    import backgroundUrl from '../assets/mycompass_loginbkg_mnt.jpg';

    export default {
        name: 'NewUser',
        data () {
            return {
                actionDialog: false,
                actionMessage: '',
                actionColor: 'error',
                actionDuration: 6000,
                submit_text: 'Create Password',
                input: {
                    password: '',
                    confirm_password: '',
                },
                passRules: [
                    (v) => v == undefined || '' || (v != undefined && v.length >= 14 || 'Password must be 14 characters long')
                ],
                cpassRules: [
                    (v) => v == undefined || '' || ((v != undefined && (this.input.password != '' && v == this.input.password)) || 'Confirmation does not match Password')
                ],
                logo_img: logo_img,
                backgroundUrl: backgroundUrl,
                emailRules: [],
                show_eye1: false,
                show_eye2: false,
            }
        },

        created () {
            document.title = 'SRG myCompass: New User'
        },

        mounted() {
            // console.log(this.$route.params)
        },

        methods: {
            logIn: async function () {
                try {

                    if ( this.input.password == undefined || this.input.confirm_password == undefined 
                         || this.input.password != this.input.confirm_password 
                         || this.input.password.length < 14 ) {

                        let password_error_msg = 'Both Password and Confirm Password must be submitted to set your password'
                        if ( this.input.password != this.input.confirm_password ) password_error_msg = 'Both Password and Confirm Password must be the same.'
                        if ( this.input.password.length < 14 ) password_error_msg = 'Password must be at least 14 characters long.'

                        this.actionDialog = true;
                        this.actionColor = 'error';
                        this.actionMessage = password_error_msg;
                        return
                    }

                    const url_decoded = this.$route.params.data.padEnd(this.$route.params.data.length + (4 - this.$route.params.data.length % 4) % 4, '=');
                    const decoded_string = Buffer.from(url_decoded, 'base64').toString('utf-8');
                    const identity = decoded_string.split('/');
                    
                    const new_user_res = await axios.post(`${appUrls.api}/api/new_user`, {
                        headers: { "content-type": "application/json" },
                        data: {
                            passes: this.input,
                            address: identity[0],
                            token: identity[1]
                        }
                    })

                    if( new_user_res.data.outcome ){
                        // console.log(new_user_res.data)
                        Cookie.set('token', new_user_res.data.sessionToken, { expires: 7, secure: true });
                        Cookie.set('is_client', new_user_res.data.landing == 'dashboard' ? true : false, { expires: 7, secure: true });
                        Cookie.set('has_profile', new_user_res.data.buyer_profile, { expires: 7, secure: true });
                        Cookie.set('name', new_user_res.data.user.first_name+' '+new_user_res.data.user.last_name, { expires: 7, secure: true });
                        Cookie.set('id', new_user_res.data.user.user_id, { expires: 7, secure: true });
                        this.$emit("authenticated", true, { expires: 7, secure: true });
                        this.$emit("isClient", new_user_res.data.landing == 'dashboard' ? true : false, { expires: 7, secure: true });
                    
                        let landing_pg = new_user_res.data.user.lockout === 2 ? 'account' : new_user_res.data.landing;
                    
                        setTimeout(() => { this.$router.replace({ path: '/'+landing_pg }); }, 1000);
                    }else{
                        this.$emit("authenticated", false);
                        this.actionMessage = new_user_res.data.message;
                        this.actionDialog = true;
                        this.close();
                    }

                } catch ( error ) {
                    console.log(error);
                    //this.actionMessage = error;
                    //this.actionDialog = true;
                }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    #signin_wrapper {
        width: 100%;
        height: 100%;
    }
    #login {
        width: 29%;
        margin: 2% auto;
        padding: 3%;
        text-align: center;
        font-size: .8rem;
        background: rgba(255, 255, 255, 0.85);
        border-radius: 8px;
    }
    .login_inputs {
        padding: 4px;
        width: 70%;
        font-size: 1em !important;
        border: 1px solid #CCCCCC;
    }
    .right_inputs {
        padding: 8px 4px;
        width: 70%;
        font-size: 1em !important;
        border: 1px solid #CCCCCC;
    }
    .return_link {
        font-size: 1.25rem;
        text-decoration: none;
        /* mdi-keyboard-backspace */
    }
    #login_btn {
        /* padding: 4px; */
        font-size: 1.3em !important;
    }
    .mnt_image {
        background-position: top left; 
        background-repeat: no-repeat; 
        background-attachment: fixed; 
        background-size: cover;
    }
    .signin_title {
        /* color: #37383C; */
        font-weight: 600;
        font-size: 1.6rem !important;
        letter-spacing: 0.05rem;
    }
</style>



// WEBPACK FOOTER //
// src/components/NewUser.vue